import { Wallet2Icon } from "lucide-react";
import { CustomHighChart } from "../ui/chart/custom-highchart";
import { ChartMainCard } from "./ChartsHeader";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";
import { useMemo } from "react";

const LeadsConversion = ({ pipData = [], totalData, lineLoading }) => {
  const getShortMonth = (fullMonth) => {
    const date = new Date(fullMonth);
    if (!isNaN(date)) {
      return date.toLocaleString("en-US", { month: "short", year: "numeric" });
    }
    const monthMap = {
      January: "Jan",
      February: "Feb",
      March: "Mar",
      April: "Apr",
      May: "May",
      June: "Jun",
      July: "Jul",
      August: "Aug",
      September: "Sep",
      October: "Oct",
      November: "Nov",
      December: "Dec",
    };
    const [monthName, year] = fullMonth.split(" ");
    return `${monthMap[monthName] || monthName} ${year}`;
  };

  const filteredData = useMemo(() => {
    const firstValidIndex = pipData?.findIndex(
      (item) => item?.conversion_rate > 0,
    );
    return firstValidIndex !== -1 ? pipData?.slice(firstValidIndex) : [];
  }, [pipData]);

  const lineOptions = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 320,
      animation: true,
    },

    title: { text: "" },

    xAxis: {
      categories: filteredData?.map((d) => d.month),
      lineColor: "#E2E8F0",
      tickColor: "#E2E8F0",
      labels: {
        style: {
          color: "#64748B",
          fontWeight: "500",
        },
      },
    },

    yAxis: {
      min: 0,
      max: 100,
      tickInterval: 20,
      title: {
        text: "Leads Conversion Rate (%)",
      },
      labels: {
        format: "{value}%",
      },
    },

    legend: { enabled: false },

    plotOptions: {
      column: {
        borderRadius: 10,
        pointWidth: 30,
        groupPadding: 0.15, // space on left & right side of each category
        pointPadding: 0.2, // space between columns
        states: {
          hover: {
            brightness: 0.15,
          },
        },
      },
    },

    tooltip: {
      pointFormat: "<b>{point.y}% Conversion</b>",
    },

    series: [
      {
        name: "Monthly Conversion",
        data: filteredData?.map((d) => d.conversion_rate),

        // 🔥 Premium Gradient
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "#6366F1"], // soft indigo
            [1, "#3B82F6"], // blue
          ],
        },
      },
    ],

    credits: { enabled: false },
  };
  return (
    <ChartMainCard
      Icon={<Wallet2Icon />}
      iconColor={"bg-theme-purple-light text-theme-purple"}
      heading="Lead Conversion Rate"
      subHeading={"Breakdown of Leads Conversion Monthly"}
    >
      {!lineLoading ? (
        <div className="p-6">
          {pipData?.length > 0 ? (
            <>
              <CustomHighChart
                isLoad={!lineLoading}
                options={lineOptions}
                titleNotFound="Leads Engagement"
              />
            </>
          ) : (
            <DataNotFound />
          )}
        </div>
      ) : (
        <InnerLoader />
      )}
    </ChartMainCard>
  );
};

export default LeadsConversion;
